// Helper condivisi per il rendering dei progetti sul frontend pubblico.

export const MESI = [
  "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];

export function formatMonthYear(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return `${MESI[d.getMonth()]} ${d.getFullYear()}`;
}

export function projectCategories(p) {
  if (!p) return [];
  if (p.categorie && p.categorie.length > 0) return p.categorie;
  if (p.categoria) return p.categoria.split(",").map((c) => c.trim()).filter(Boolean);
  return [];
}

// Costruisce la lista di immagini per un progetto:
// cover come prima (se non è già in galleria), poi le altre.
export function projectImages(project) {
  const cover = project?.cover_image_url;
  const gallery = project?.immagini || [];
  if (cover && !gallery.some((g) => g.image_url === cover)) {
    return [{ image_url: cover }, ...gallery];
  }
  if (gallery.length > 0) return gallery;
  if (cover) return [{ image_url: cover }];
  return [];
}
